const en = {
  embed_acadly_polls: 'Embed Acadly polls',
  display_student_responses_in_the_slide: 'Display student responses in the slide',
  take_attendance: 'Take attendance',
  mark_presence_of_hundreds_without_breaking_flow: 'Mark presence of hundreds without breaking flow',

  /** login - email page */
  log_in: 'Log in',
  registered_email: 'Registered email',
  email_address: 'Email address',
  enter_your_email_here: 'Enter your email here',
  don_t_have_an_acadly_account_yet: 'Don’t have an Acadly account yet?',
  sign_up_here: 'Sign up here.',
  click_to_create_a_new_account: 'click to create a new account',
  this_email_id_does_not_exist: 'This email id does not exist',
  click_to_signup_instead: 'click to signup instead',
  back_to_login: 'Back to login',
  you_dont_have_access_to_the_plugin_learn_more: 'You don’t have access to the plugin. Learn more',

  /** login - password page */
  welcome_back: 'Welcome back!',
  enter_your_password_here: 'Enter your password here',
  forgot_password: 'Forgot password?',
  click_to_go_to_forgot_password_page: 'click to go to forgot password page',
  click_to_login: 'click to login',

  /** login - sso page */
  log_in_again: 'Log in again',
  authentication_process_active_in_another_window: 'Authentication process active in another window...',
  sign_in_process_could_not_be_completed_please_try_again:
    'Sign in process could not be completed, please try again',
};

export default en;
